import { Moon, Sun } from 'lucide-react'
import { useTheme } from '@/lib/theme'
import { cn } from '@/lib/utils'
import { Tooltip } from '@/components/ui'

/** Light / dark background switch (remembered on this browser). */
export function ThemeToggle({ className }: { className?: string }) {
  const { theme, toggle } = useTheme()
  const dark = theme === 'dark'
  return (
    <Tooltip content={dark ? 'Switch to light background' : 'Switch to dark background'}>
      <button
        type="button"
        role="switch"
        aria-checked={dark}
        aria-label="Dark background"
        onClick={toggle}
        className={cn('relative inline-flex h-8 w-[60px] shrink-0 items-center rounded-full border border-ink-200 bg-ink-100 p-0.5 transition-colors hover:border-ink-300', className)}
      >
        <span className={cn('absolute top-0.5 h-[26px] w-[26px] rounded-full bg-surface shadow-sm transition-transform', dark ? 'translate-x-[28px]' : 'translate-x-0')} />
        <Sun className={cn('relative z-10 ml-[5px] h-4 w-4', dark ? 'text-ink-500' : 'text-accent')} aria-hidden />
        <Moon className={cn('relative z-10 ml-auto mr-[5px] h-4 w-4', dark ? 'text-brand-700' : 'text-ink-500')} aria-hidden />
      </button>
    </Tooltip>
  )
}
